/**
 * Client-side search over the IM tabs' chat list.
 *
 * WhatsApp Web opens its chat column with a search field, and the tab must read
 * as the real client. A decorative one would be a lie on a monitoring surface,
 * so this filters the conversations the pane ALREADY holds — no new round trip,
 * no server query, and therefore no claim that it searches message history it
 * has not loaded.
 *
 * Accent- and case-insensitive, because a lawyer typing "goncalves" must find
 * "Gonçalves".
 */

/** Fold case + diacritics for a forgiving substring match. */
export function foldForSearch(s: string): string {
  return s
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "")
    .toLowerCase()
    .trim();
}

/**
 * Does any of `fields` contain `query`? An empty/whitespace query matches
 * everything (the field is a filter, not a gate). Every term must appear in at
 * least one field, so "ana silva" finds a row named "Ana da Silva".
 */
export function matchesSearch(query: string, fields: (string | null | undefined)[]): boolean {
  const q = foldForSearch(query);
  if (!q) return true;
  const hay = fields.filter(Boolean).map((f) => foldForSearch(f as string));
  return q.split(/\s+/).every((term) => hay.some((f) => f.includes(term)));
}
